var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "15 -3 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_3077_9214)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 33,
    height: 33,
    rx: 8.72727,
    fill: "#38D200"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.192 7.8999C41.466 7.8999 42.6915 8.4034 43.593 9.30685C44.4955 10.2084 45 11.4244 45 12.6974V20.2024C45 22.8529 42.8435 24.9999 40.192 24.9999H30.807C28.1556 24.9999 26 22.8529 26 20.2024V12.6974C26 10.0469 28.146 7.8999 30.807 7.8999H40.192ZM41.7035 14.1128L41.7795 14.0368C42.0066 13.7613 42.0066 13.3623 41.7691 13.0868C41.637 12.9452 41.4556 12.8588 41.2665 12.8398C41.067 12.8293 40.877 12.8968 40.7336 13.0298L36.45 16.4498C35.899 16.9067 35.1096 16.9067 34.55 16.4498L30.275 13.0298C29.9796 12.8113 29.5711 12.8398 29.325 13.0963C29.0685 13.3528 29.04 13.7613 29.2576 14.0463L29.382 14.1698L33.7045 17.5423C34.2365 17.9603 34.8816 18.1883 35.557 18.1883C36.2306 18.1883 36.887 17.9603 37.4181 17.5423L41.7035 14.1128Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_3077_9214",
    x: 0.4,
    y: -4.36364,
    width: 70.2,
    height: 75.1636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.18182
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3077_9214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 9,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3077_9214"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.290196 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_3077_9214",
    result: "effect2_dropShadow_3077_9214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3077_9214",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0ae6419948729fbff9cddf522a7c35ab.svg";
export { ForwardRef as ReactComponent };